import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ThemePalette } from '@angular/material/core';
import { MatFormFieldModule, SubscriptSizing } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-search-input',
  template: `
    <mat-form-field [color]="color" class="sm-full-width" [appearance]="appearance" [subscriptSizing]="subscriptSizing">
      <mat-label>{{ 'shared.search' | translate }}</mat-label>
      <input #input matInput placeholder="" autocomplete="off" (keyup)="onKeyUp($event)" />
      <mat-icon matSuffix color="accent">search</mat-icon>
    </mat-form-field>
  `,
  styles: [
    `
      :host {
        display: block;
        padding: 0;
        margin: 0;
      }
    `,
  ],
  standalone: true,
  imports: [TranslateModule, MatIconModule, MatFormFieldModule, MatInputModule],
})
export class SearchInputComponent {
  @Input() appearance: 'fill' | 'outline';
  @Input() color: ThemePalette = 'accent';
  @Input() subscriptSizing: SubscriptSizing = 'fixed';
  @Output() keyupp = new EventEmitter<string>();

  onKeyUp(event: KeyboardEvent) {
    this.keyupp.emit((event.target as HTMLInputElement).value);
  }
}
